/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Einvoice_Badge_DuplicatedInputs */

const vi_einvoice_badge_duplicated = /** @type {(inputs: Einvoice_Badge_DuplicatedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`MISA báo trùng, cần tra`)
};

/**

* @param {Einvoice_Badge_DuplicatedInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const einvoice_badge_duplicated = /** @type {((inputs?: Einvoice_Badge_DuplicatedInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Einvoice_Badge_DuplicatedInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_einvoice_badge_duplicated(inputs)
});